angular.module('cvsApp').factory('getSpecialtyWCMContentModel',['commonModel',function(CM) {	
	'use strict';
	var getContentModel = function(){

		var self = this;

		self.apiResponse = {};
		
		this.setResponse = function(data){
			CM.setResponse(data);			
		};	

		this.getResponse = function(data){
			self.apiResponse = CM.getResponse();	
			return self;		
		};	

		this.showView = function(){
			if(self.apiResponse.isViewError){	
				return !self.apiResponse.isViewError;
			}
			return true;
		};

		this.getError = function(){
			if(self.apiResponse.showError){	
				return self.apiResponse.showError;
			}
			return "";
		};

		
		this.getContent = function(){
			if(!self.apiResponse.showError){
				return self.apiResponse;
			}	
				
		};
	
	};
	
	return new getContentModel();
}]);